export const FRONTEND_URL= process.env.REACT_APP_FRONTEND_URL
export const API_URL= process.env.REACT_APP_API_URL
export const API_URL_UM= process.env.REACT_APP_API_URL_UM
export const API_UM_SECRET= process.env.REACT_APP_API_UM_SECRET
export const API_URL_LUTECE = process.env.REACT_APP_API_URL_LUTECE